module.exports = __webpack_public_path__ + "static/img/图层52.1809fae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层52.png
// module id = K16y
// module chunks = 0